// 1. The runtime constant object
export const MFA = {
	EMAIL: "email",
	SMS: "sms",
	TOTP: "totp",
} as const;

// 2. The derived TypeScript type ("EMAIL" | "SMS" | "TOTP")
export type MfaType = (typeof MFA)[keyof typeof MFA];
